import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";
toast.configure();


/**
 * @description function use for to get dashboard data
 * @param {*} params accepting object
 */
export const getUploadedPackets = (params, callback) => {
  return (dispatch, getState) => {
    const { user: { token }} = getState();
    ApiClient.get(`${apiUrl}${PORT}/dashboard`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          dispatch({
            type: "DASHBOARD_DATA",
            data: response
          });

          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};

/**
 * @description function use for to update uploaded packets graph
 * @param {*} params accepting object
 */
export const getPacketsGraphData = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/dashboard/uploadedPackets`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};


/**
 * @description function use for to update uploaded files graph
 * @param {*} params accepting object
 */
export const getFilesGraphData = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/dashboard/uploadedFiles`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};

export const appendQueueList = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(
      `${apiUrl}${PORT}/dashboard/queue`,
      params,
      token,
      dispatch
    ).then((response) => {
      if (response && !response.errors) {
        dispatch({ type: "APPEND_QUEUE_LIST", data: response });
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };
};




/**
 * @description function use for to get file processed today and yesterday
 * @param {*} params accepting object
 */
export const getFilesProcessed = (callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/dashboard/getFilesProcessed`, null, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
          callback();
        } else {
          toast.error(response.errors.msg, toasterConfig);
          callback();
        }
      }
    );
  };
};






/**
 * @description function use for to get dashboard data
 * @param {*} params accepting object
 */
export const getPacketsPieChartData = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/dashboard/getPacketsPieChartData`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {

          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};




/**
 * @description function use for to get get Manually Checked document today and yesterday
 * @param {*} params accepting object
 */
export const getManuallyCheckedItem = (callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/dashboard/getManuallyCheckedItem`, null, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
          callback();
        } else {
          toast.error(response.errors.msg, toasterConfig);
          callback();
        }
      }
    );
  };
};





export const getAutoSaveData = () => {

  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/dashboard/getAutoSaveData`, {}, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          dispatch({
            type: "SET_AUTOSAVE_DATA",
            data: response
          });
        }
      }
    );
  };
};

